import React, { type FunctionComponent, Fragment, useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/react'
import AppHeader from 'legacy/components/AppHeader'
import { spacing } from 'gin-and-tonic/foundation/spacing'
import { useSandboxOrder } from 'domains/connect/components/fulfillment-simulator/utils/sandboxOrder.hooks'
import { OrderFilters } from 'domains/connect/components/fulfillment-simulator/OrderFilters'
import { OrderSimulationOverview } from 'domains/connect/components/fulfillment-simulator/OrderSimulationOverview'

const containerStyles = css`
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: ${spacing.X20} auto;
  width: 100%;
`

export const ConnectFulfillmentSimulator: FunctionComponent = () => {
  const [orderId, setOrderId] = useState<string>('')
  const { sandboxOrder, loading, error } = useSandboxOrder(orderId)
  // TODO: use error

  return (
    <Fragment>
      <AppHeader title={<FormattedMessage id="connect.fulfillmentSimulator.header" />} />
      <OrderFilters initialOrderId={orderId} onSubmit={setOrderId} />
      <div css={containerStyles}>
        <OrderSimulationOverview sandboxOrder={sandboxOrder} />
      </div>
    </Fragment>
  )
}
